import React from 'react';

import classNames from 'classnames';

import Tooltip from 'CommonComponents/Tooltip';

import CircleInfoIcon from 'Assets/icons/circle-info.svg';

export default function SelectInput({
    isHtmlLabel = false,
    label,
    info,
    showError = false,
    errorText = '',
    horizontalLayout = false,
    parentGridClass = 'tw-grid-cols-3',
    labelGridClass = 'tw-col-span-1',
    inputGridClass = 'tw-col-span-2',
    infoBackgroundClass = '',
    selectInfo = '',
    ...props
}) {
    return horizontalLayout ? (
        <div className={parentGridClass + ' tw-grid tw-gap-4'}>
            {!!label && (
                <div className={classNames('tw-flex tw-items-center tw-gap-x-1.5', labelGridClass)}>
                    {isHtmlLabel ? (
                        <label htmlFor={props.name} className="tw-text-charcoal tw-text-sm tw-mb-0" dangerouslySetInnerHTML={{ __html: label }}></label>
                    ) : (
                        <label htmlFor={props.name} className="tw-text-charcoal tw-text-sm tw-mb-0">
                            {label} {props.required && '*'}
                        </label>
                    )}
                    {info && (
                        <Tooltip placement="top-end" tooltipContent={info} tooltipType="text" backgroundClass={infoBackgroundClass}>
                            <div>
                                <CircleInfoIcon className="tw-w-4 tw-h-4 tw-text-blue" />
                            </div>
                        </Tooltip>
                    )}
                </div>
            )}
            {!!selectInfo && (
                <Tooltip placement="top-end" tooltipContent={selectInfo} tooltipType="text" backgroundClass={infoBackgroundClass}>
                    <div className={inputGridClass + ' tw-flex tw-flex-col tw-space-y-1.5'}>
                        <select className={showError ? 'tw-border tw-border-red-500 select-input' : 'tw-border-0 select-input'} {...props}>
                            {props.children}
                        </select>
                        {showError ? <div className="tw-text-red-500 tw-text-sm">{errorText}</div> : null}
                    </div>
                </Tooltip>
            )}
            {!selectInfo && (
                <div className={inputGridClass + ' tw-flex tw-flex-col tw-space-y-1.5'}>
                    <select className={showError ? 'tw-border tw-border-red-500 select-input' : 'tw-border-0 select-input'} {...props}>
                        {props.children}
                    </select>
                    {showError ? <div className="tw-text-red-500 tw-text-sm">{errorText}</div> : null}
                </div>
            )}
        </div>
    ) : (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            {!!label && (
                <div className="tw-flex tw-items-center tw-gap-x-1.5">
                    {isHtmlLabel ? (
                        <label htmlFor={props.name} className="tw-text-charcoal tw-text-sm tw-mb-0" dangerouslySetInnerHTML={{ __html: label }}></label>
                    ) : (
                        <label htmlFor={props.name} className="tw-text-charcoal tw-text-sm tw-mb-0">
                            {$t(label)} {props.required && '*'}
                        </label>
                    )}
                    {info && (
                        <Tooltip placement="top-end" tooltipContent={info} tooltipType="text" backgroundClass={infoBackgroundClass}>
                            <div>
                                <CircleInfoIcon className="tw-w-4 tw-h-4 tw-text-blue" />
                            </div>
                        </Tooltip>
                    )}
                </div>
            )}

            {!!selectInfo && (
                <Tooltip placement="top-end" tooltipContent={selectInfo} tooltipType="text" backgroundClass={infoBackgroundClass}>
                    <div>
                        <select className={showError ? 'tw-border tw-border-red-500 select-input' : 'tw-border-0 select-input'} {...props}>
                            {props.children}
                        </select>
                        {showError ? <div className="tw-text-red-500 tw-text-sm">{errorText}</div> : null}
                    </div>
                </Tooltip>
            )}

            {!selectInfo && (
                <div>
                    <select className={showError ? 'tw-border tw-border-red-500 select-input' : 'tw-border-0 select-input'} {...props}>
                        {props.children}
                    </select>
                    {showError ? <div className="tw-text-red-500 tw-text-sm">{errorText}</div> : null}
                </div>
            )}
        </div>
    );
}
